module.exports = "/assets/2127542d08cd2b7fcae286cbdbc93c5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/8T.png
// module id = 2277
// module chunks = 0